export default class RecurrenceIntervals {
    static RECURRENCE_INTERVAL_NONE = 0;
    static RECURRENCE_INTERVAL_1_WEEK = 1;
    static RECURRENCE_INTERVAL_2_WEEK = 2;
    static RECURRENCE_INTERVAL_3_WEEK = 3;
    static RECURRENCE_INTERVAL_4_WEEK = 4;
}